import { render } from "./OopsPage.vue?vue&type=template&id=00312a99"
import script from "./OopsPage.vue?vue&type=script&lang=js"
export * from "./OopsPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__